import React, {Component} from "react";
import {withRouter} from "react-router-dom";
import {Button, Navbar} from "react-bootstrap";
import Routes from "./Routes";
import AuthService from './services/AuthService'
import "./App.css"
import IdleTimer from 'react-idle-timer';
import {IDLE_TIMER} from './constants/Constants'
import DashboardService from "./services/DashboardService";
class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isAuthenticated: false,
            isAuthenticating: true
        };
    }

    userHasAuthenticated = authenticated => {
        this.setState({isAuthenticated: authenticated});
    };

    handleLogout = async event => {
        await AuthService.logout();
        await DashboardService.clearReduxData();
        this.userHasAuthenticated(false);
        this.props.history.push("/login");
    };

    async componentDidMount() {
        const auth = await AuthService.isAuthenticated();
        if (auth) {
            this.userHasAuthenticated(true);
        }
        this.setState({isAuthenticating: false});
    }

    handleOnIdle = async event => {
        this.handleLogout(); 
    }

    render() {
        const childProps = {
            isAuthenticated: this.state.isAuthenticated,
            userHasAuthenticated: this.userHasAuthenticated
        };
        
        return (
            //!this.state.isAuthenticating &&
            <div className="App">
		        <IdleTimer
                  ref={ref => { this.idleTimer = ref }}
                  timeout={IDLE_TIMER.TIMEOUT}
                  onActive={this.handleOnActive}
                  onIdle={this.handleOnIdle}
                  onAction={this.handleOnAction}
                  debounce={IDLE_TIMER.DEBOUNCE}
                />
                <Navbar className="navbar navbar-inverse">
                    <div className="container">
                        <Navbar.Brand>{'Nuro'}</Navbar.Brand>
                        {this.state.isAuthenticated ?
                            <div>
                                <Button id="link_devices_id" variant="link" style={{marginTop: 8}}
                                        onClick={this.navigateToDashboard}>Users</Button>
                                <Button id="link_build_id" variant="link" style={{marginTop: 8}} 
                                        onClick={this.navigateToBuild}>Build</Button>
                                <Button id="link_deviceManagement_id" variant="link" style={{marginTop: 8}} 
                                        onClick={this.navigateToDeviceManagement}>Device Management</Button>                  
                                <Button id="link_logs_id" variant="link" style={{marginTop: 8}} 
                                        onClick={this.navigateToLogs}>Logs</Button>    
                                <Button id="link_account_management_id" variant="link" style={{marginTop: 8}} 
                                        onClick={this.navigateToAccountManagement}>Account Management</Button>    
                                <Button
				    id="link_logout_id"
                                    style={{marginTop: 8}}
                                    className="pull-right"
                                    onClick={this.handleLogout}>Logout</Button>
				<label
				  id="label_deviceconfiguration_id"
				  style={{ "color": "white", "display": "none", "marginLeft": "35%"  }}
				  className = "navbar-brand"
				>
				  Device Configuration
				</label>
				<Button
				  id="link_close_id"
				  style={{ marginTop: 8, display: "none" }}
				  className="pull-right"
				  onClick={this.handleClose}
				>
				  Close
				</Button>
                            </div>
                            : null
                        }
                    </div>
                </Navbar>
                
                <Routes childProps={childProps}/>
            </div>
        );
    }
    
    handleClose = () => {
		window.close();
	};

    navigateToDashboard = event => {
        this.props.history.push("/dashboard")
    };

    navigateToBuild = event => {
        this.props.history.push("/build")
    }

    navigateToDeviceManagement = event => {
        this.props.history.push("/deviceManagement")
    }

    navigateToLogs = event => {
        this.props.history.push("/logs")
    }

    navigateToAccountManagement = event => {
        this.props.history.push("/accounts")
    }
}

export default withRouter(App);

